/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./takePhoto.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../../../services/user.service";
import * as i3 from "@angular/http";
import * as i4 from "./takePhoto.component";
var styles_TakePhotoComponent = [i0.styles];
var RenderType_TakePhotoComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_TakePhotoComponent, data: {} });
export { RenderType_TakePhotoComponent as RenderType_TakePhotoComponent };
export function View_TakePhotoComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_TakePhotoComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 2, "page-takephoto", [], null, null, null, View_TakePhotoComponent_0, RenderType_TakePhotoComponent)), i1.ɵprd(512, null, i2.UserService, i2.UserService, [i3.Http]), i1.ɵdid(2, 49152, null, 0, i4.TakePhotoComponent, [i2.UserService], null, null)], null, null); }
var TakePhotoComponentNgFactory = i1.ɵccf("page-takephoto", i4.TakePhotoComponent, View_TakePhotoComponent_Host_0, {}, {}, []);
export { TakePhotoComponentNgFactory as TakePhotoComponentNgFactory };
